import {
  SingleTrainFormSchema,
  TrainCustomEventSchema,
  TrainFormSchema,
} from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { TrainEventTypeEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainEventTypeEnum";
import { FC, useEffect, useRef } from "react";
import { FieldErrorsImpl, useFormContext } from "react-hook-form";
import {
  Checkbox,
  Field,
  FieldErrorText,
  Flex,
  Textarea,
} from "shared/components/Spor";

type DropsLogTextInputProps = {
  previewText?: string;
};

export const DropsLogTextInput: FC<DropsLogTextInputProps> = ({
  previewText,
}) => {
  const { getValues, setValue, formState } =
    useFormContext<SingleTrainFormSchema>();

  // TRAIN_CUSTOM is the only field which doesn't have dropsLogText, in which case this component isn't shown
  // so we can safely narrow the type of the error object
  const formErrors = formState.errors.trainForm as
    | FieldErrorsImpl<Exclude<TrainFormSchema, TrainCustomEventSchema>>
    | undefined;

  const trainEvent = getValues("trainForm.type");

  const dropsLogTextEnabled = getValues("trainForm.dropsLogText.enabled");
  const dropsLogText = getValues("trainForm.dropsLogText.texts.NOB");

  const previousPreviewText = useRef<string | undefined>(previewText);
  useEffect(() => {
    if (!previewText) return;
    // Update the text field contents if the preview changes and the text field has not been manually changed
    const isEmpty = !dropsLogText || !previousPreviewText.current;
    const isUnchanged = dropsLogText === previousPreviewText.current;
    if (isEmpty || isUnchanged) {
      setValue("trainForm.dropsLogText.texts.NOB", previewText);
    }
    previousPreviewText.current = previewText;
  }, [previewText]);

  useEffect(() => {
    // Enable DROPS_LOG by default for TRAIN_STOPPED
    if (trainEvent === TrainEventTypeEnum.TRAIN_STOPPED) {
      setValue("trainForm.dropsLogText.enabled", true);
    }
  }, [trainEvent]);

  return (
    <Flex gap="12px" flexDir="column">
      <Checkbox
        checked={dropsLogTextEnabled}
        onCheckedChange={() =>
          setValue("trainForm.dropsLogText.enabled", !dropsLogTextEnabled)
        }
      >
        Send melding til Operativ logg
      </Checkbox>
      {dropsLogTextEnabled && (
        <Field invalid={!!formErrors?.dropsLogText}>
          <Textarea
            label="Melding*"
            value={dropsLogText}
            onChange={(e) =>
              setValue("trainForm.dropsLogText.texts.NOB", e.target.value)
            }
          />
          <FieldErrorText>
            {formErrors?.dropsLogText?.texts?.NOB?.message}
          </FieldErrorText>
        </Field>
      )}
    </Flex>
  );
};
